import { lazy } from 'react';

import withSuspense from 'components/Decorators/withSuspense';

const SvgIcon = withSuspense(
  lazy(() => import('@picsart/rc/old/SvgIcon')),
  null,
);

export default SvgIcon;
